module.exports = __webpack_public_path__ + "img/trash.1548a3ca.svg";